<template>
	<div v-if="flex === 'equal'">
		<v-layout row style="margin-top: 5px">
			<v-flex xs3>
				<h4 :style="'text-align: ' + labelAlign">{{ label }}{{ showColon === true ? ':' : '' }}</h4>
			</v-flex>
			<v-flex xs9 ml-2>
				<h4 :style="'text-align: ' + valueAlign">{{value}}</h4>
			</v-flex>
		</v-layout>
	</div>
	<div v-else-if="flex === 'reversed'">
		<v-layout row style="margin-top: 5px">
			<v-flex xs4>
				<h4 :style="'text-align: ' + labelAlign">{{ label }}{{ showColon === true ? ':' : '' }}</h4>
			</v-flex>
			<v-flex xs8 ml-2>
				<h4 :style="'text-align: ' + valueAlign">{{ value }}</h4>
			</v-flex>
		</v-layout>
	</div>
	<div v-else-if="flex === 'full-width'">
		<v-layout row style="margin-top: 5px">
			<v-flex xs4 lg3>
				<h4 :style="'text-align: ' + labelAlign">{{ label }}{{ showColon === true ? ':' : '' }}</h4>
			</v-flex>
			<v-flex xs8 lg6 ml-2>
				<h4 :style="'text-align: ' + valueAlign">{{ value }}</h4>
			</v-flex>
		</v-layout>
	</div>
	<div v-else-if="flex === 'wide-titled'">
		<v-layout row style="margin-top: 5px">
			<v-flex xs6>
				<h4 :style="'text-align: ' + labelAlign">{{ label }}{{ showColon === true ? ':' : '' }}</h4>
			</v-flex>
			<v-flex xs6 ml-2>
				<h4 :style="'text-align: ' + valueAlign">{{ value }}</h4>
			</v-flex>
		</v-layout>
	</div>
	<div v-else>
		<v-layout row style="margin-top: 5px">
			<v-flex xs2>
				<h4 :style="'text-align: ' + labelAlign">{{ label }}{{ showColon === true ? ':' : '' }}</h4>
			</v-flex>
			<v-flex xs10 ml-2>
				<h4 :style="'text-align: ' + valueAlign">{{ value }}</h4>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	export default {
		name: "DisplayTextComponent",
		props: {
			flex: {
				type: String
			},
			label: {
				type: String,
				required: true,
			},
			value: {
				type: [String, Number],
			},
			labelAlign: {
				type: String,
				default: "left"
			},
			valueAlign: {
				type: String,
				default: "left"
			},
			showColon: {
				type: Boolean,
				default: true
			},
			data() {
				return {
					valueLoaded: false,
					labelLoaded: false
				};
			}
		}
	};
</script>

<style scoped>

</style>
